<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane :label="areaTabText" name="area">
      <div class="area-container">
        <area-table
          :tableData="areaTableData"
          :totalCount="areaTotalCount"
          downloadUrl="/concerned/concernedListDownload"
        ></area-table>
      </div>
    </el-tab-pane>
    <el-tab-pane :label="circuitTabText" name="circuit">
      <div class="circuit-container">
        <CircuitTable
          :tableData="circuitTableData"
          :totalCount="circuitTotalCount"
          downloadUrl="/concerned/concernedListDownload"
        ></CircuitTable>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import AreaTable from "../area/components/AreaTable.vue";
import CircuitTable from "../circuit/components/CircuitTable.vue";
import {
  fetchConcernList,
  // fetchCancelConcern,
  // fetchAddConcern,
} from "@/utils/api/concerned";
export default {
  components: {
    AreaTable,
    CircuitTable,
  },
  data() {
    return {
      activeName: "area",
      areaCheckRows: [],
      areaTotalCount: 0,
      areaTableData: [],
      areaMultiButton: true,
      circuitCheckRows: [],
      circuitTotalCount: 0,
      circuitTableData: [],
      circuitMultiButton: true,
    };
  },
  mounted() {
    // 重置筛选（获取list）
    this.$store.dispatch("com/resetAreaTableFilter");
    this.$store.dispatch("com/resetCircuitTableFilter");
  },
  computed: {
    areaTableFilter() {
      return this.$store.getters.areaTableFilter;
    },
    circuitTableFilter() {
      return this.$store.getters.circuitTableFilter;
    },
    areaTabText() {
      return "关注的地区(" + this.areaTotalCount + ")";
    },
    circuitTabText() {
      return "关注的路线(" + this.circuitTotalCount + ")";
    },
  },
  watch: {
    areaTableFilter() {
      this.getAreaConcernList();
    },
    circuitTableFilter() {
      this.getCircuitConcernList();
    },
  },
  methods: {
    handleClick() {
      // console.log(tab, event);
    },
    getAreaConcernList() {
      fetchConcernList({
        ...this.areaTableFilter,
        type: 0,
      })
        .then(({ data }) => {
          this.areaTableData = data.datas.map((item) => {
            item.concernStatus = 1;
            return item;
          });
          this.areaTotalCount = data.total;
        })
        .finally(() => {
          this.$store.dispatch("com/setAreaTableLoading", false);
        });
    },
    getCircuitConcernList() {
      fetchConcernList({
        ...this.circuitTableFilter,
        type: 1,
      })
        .then(({ data }) => {
          this.circuitTableData = data.datas.map((item) => {
            item.concernStatus = 1;
            return item;
          });
          this.circuitTotalCount = data.total;
        })
        .finally(() => {
          this.$store.dispatch("com/setCircuitTableLoading", false);
        });
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.area-container {
  height: calc(100vh - 200px);
}

.circuit-container {
  height: calc(100vh - 260px);
}
</style>
